import "@/App.css";
import "./i18n/config";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { MainLayout } from "./components/Layout/MainLayout";
import { Login } from "./pages/Login";
import { PatrolLogin } from "./pages/PatrolLogin";
import { Dashboard } from "./pages/Dashboard";
import { Companies } from "./pages/Companies";
import { Users } from "./pages/Users";
import { Checkpoints } from "./pages/Checkpoints";
import { Routes as RoutesPage } from "./pages/Routes";
import { Patrol } from "./pages/Patrol";
import { PatrolLogs } from "./pages/PatrolLogs";
import { Payroll } from "./pages/Payroll";
import { Setup } from "./pages/Setup";
import { GuardLoginRecords } from "./pages/GuardLoginRecords";
import { ActiveGuards } from "./pages/ActiveGuards";
import Holidays from "./pages/Holidays";
import CompanySettings from "./pages/CompanySettings";
import { ChangePassword } from "./pages/ChangePassword";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/patrol/login" element={<PatrolLogin />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/change-password" element={<ChangePassword />} />
          
          {/* Patrol route (separate from main layout) */}
          <Route path="/patrol" element={<Patrol />} />
          
          {/* Protected routes with main layout */}
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/users" element={<Users />} />
            <Route path="/checkpoints" element={<Checkpoints />} />
            <Route path="/routes" element={<RoutesPage />} />
            <Route path="/patrol-logs" element={<PatrolLogs />} />
            <Route path="/guard-records" element={<GuardLoginRecords />} />
            <Route path="/active-guards" element={<ActiveGuards />} />
            <Route path="/payroll" element={<Payroll />} />
            <Route path="/holidays" element={<Holidays />} />
            <Route path="/company-settings" element={<CompanySettings />} />
          </Route>
          
          {/* Redirect root to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;
